"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = void 0;
exports.FEATURE_FLAGS = [
    'AI_VACCINATION_DOCUMENTS',
    'BILLING_INVOICES',
    'EXPIRATION_GRACE_PERIOD',
    'FACILITY_INTEREST',
    'HELP_SUPPORT_PAGE',
    'I9_FORM_ENABLED',
    'ON_CALL_SHIFTS',
    'PAY_HISTORY',
    'PROFILE_INTAKE',
    'PROPOSE_SHIFT_CHANGES',
    'RATE_CALCULATOR',
    'TIMECARD_FULL_PAGE_LIST',
    'WORK_QUALIFICATION_MODAL_TEST',
];
//# sourceMappingURL=feature-flags.js.map